import client from './client';

export default (function InviteService() {
  let service;

  if (!service) {
    service = client.service('invites');
  }

  return service;
}());
